import React from 'react'
import upperCase from 'lodash/upperCase'
import moment from 'moment'
import {AutoSizer, Table, Column, InfiniteLoader} from 'react-virtualized'
import {AuditContext} from '../../../context/Audits'
import {data} from 'jquery'
import Spinner from 'react-bootstrap/Spinner'

function TableAssignedTo(props) {
  console.log(props.data.individual_audit)

  let auditid = props.data.id
  const {assignTo, getAssigTo} = React.useContext(AuditContext)
  const [selectedItem, setSelectedItem] = React.useState(null)

  React.useEffect(() => {
    getAssigTo(auditid)
  }, [getAssigTo, auditid])

  const _noRowsRenderer = () => {
    return (
      <div className="text_center audit-table__cell--none audit-table__cell--gray audit-table__cell--expand">
        <span className="font_20">No Records Found</span>
      </div>
    )
  }

  return (
    <div className="main-container">
      <h1 className="tableTitleText">
        Infinite scrolling autosize table for unlisted item for specific audit with details
      </h1>
      {!assignTo.isLoading && assignTo.assignedto ? (
        <InfiniteLoader>
          {({onRowsRendered, registerChild}) => (
            <AutoSizer className="full_auto_width">
              {({width}) => (
                <Table
                  ref={registerChild}
                  onRowsRendered={onRowsRendered}
                  className="audit-table"
                  rowClassName="audit-table__row audit-table__row--35 audit-table__row--no-border-top"
                  headerHeight={33}
                  height={545}
                  width={width}
                  rowHeight={33}
                  rowCount={
                    assignTo.assignedto.data.audit_users
                      ? assignTo.assignedto.data.audit_users.length
                      : 0
                  }
                  rowGetter={({index}) =>
                    assignTo.assignedto.data.audit_users
                      ? assignTo.assignedto.data.audit_users[index]
                      : []
                  }
                  rowStyle={{overflow: 'visible'}}
                  noRowsRenderer={_noRowsRenderer}
                >
                  <Column
                    className="item-table__header"
                    cellRenderer={c => (
                      <div className="overflow-content audit--asignto-tab">
                        {props?.data.individual_audit ? (
                          <span
                            className={
                              c.rowData.completion_date
                                ? 'audit_user--statusgreen'
                                : 'audit_user--statusred'
                            }
                          ></span>
                        ) : null}

                        {c.rowData.full_name}
                      </div>
                    )}
                    label={upperCase('Name')}
                    dataKey="scanned_code"
                    width={width * 0.25}
                  />
                  <Column
                    className="item-table__header"
                    cellRenderer={c => <div className="overflow-content">{c.rowData.email}</div>}
                    label={upperCase('Email')}
                    dataKey="comment"
                    width={width * 0.25}
                  />
                  <Column
                    className="item-table__header"
                    cellRenderer={c =>
                      c.rowData.completion_date
                        ? moment(c.rowData.completion_date).format('MM/DD/YYYY')
                        : '-'
                    }
                    label={upperCase('Date closed')}
                    dataKey="id"
                    width={width * 0.2}
                  />
                  <Column
                    className="item-table__header"
                    cellRenderer={c => (
                      <div className="overflow-content">
                        {c.rowData.total_scanned_count}/{c.rowData.entity_objects_count}
                      </div>
                    )}
                    label={upperCase('Scanned')}
                    dataKey="comment"
                    width={width * 0.1}
                  />
                  <Column
                    className="item-table__header"
                    cellRenderer={c => (
                      <div className="overflow-content">{c.rowData.unlisted_count}</div>
                    )}
                    label={upperCase('Unlisted')}
                    dataKey="comment"
                    width={width * 0.1}
                  />

                  <Column
                    className="item-table__header"
                    cellRenderer={c => (
                      <div className="overflow-content">{c.rowData.new_item_count}</div>
                    )}
                    label={upperCase('new Items')}
                    dataKey="comment"
                    width={width * 0.1}
                  />
                </Table>
              )}
            </AutoSizer>
          )}
        </InfiniteLoader>
      ) : null}
    </div>
  )
}

export default TableAssignedTo
